import React from 'react';
import { AboutSection } from '../components/AboutSection';
import { ProcessSection } from '../components/ProcessSection';

export const About: React.FC = () => {
  return (
    <div className="pt-20">
      <AboutSection />
      <ProcessSection />
    </div>
  );
};
